import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { AlertCircleIcon, BriefcaseIcon, FileTextIcon, InboxIcon, LayoutDashboardIcon, LogOutIcon, ReceiptIcon, SettingsIcon, UsersIcon } from 'lucide-react';
import { useAdminData } from '../../contexts/AdminDataContext';
import { company } from '../../data/site';
const nav = [{
  label: 'Overblik',
  to: '/admin',
  icon: LayoutDashboardIcon,
  end: true
}, {
  label: 'Henvendelser',
  to: '/admin/henvendelser',
  icon: InboxIcon,
  end: false
}, {
  label: 'Tilbud',
  to: '/admin/tilbud',
  icon: FileTextIcon,
  end: false
}, {
  label: 'Sager',
  to: '/admin/sager',
  icon: BriefcaseIcon,
  end: false
}, {
  label: 'Fakturaer',
  to: '/admin/fakturaer',
  icon: ReceiptIcon,
  end: false
}, {
  label: 'Kunder',
  to: '/admin/kunder',
  icon: UsersIcon,
  end: false
}, {
  label: 'Indstillinger',
  to: '/admin/indstillinger',
  icon: SettingsIcon,
  end: false
}];
export function AdminShell() {
  const {
    logout,
    dataError,
    rulesError,
    enquiries
  } = useAdminData();
  const navigate = useNavigate();
  const newEnquiries = enquiries.filter(item => item.status === 'Ny henvendelse').length;
  async function handleLogout() {
    await logout();
    navigate('/admin/login');
  }
  return <div className="flex min-h-screen w-full bg-canvas lg:flex-row" data-id="element-42" data-mp="3aszboue89mtg">
      <aside className="hidden w-56 shrink-0 flex-col border-r border-line bg-white lg:flex" data-id="element-43" data-mp="35rjn4scucy6b">
        <div className="px-6 py-6" data-id="element-44" data-mp="3jrayelbz40gm">
          <img src={company.logoWide} alt="LYKKEVÆRK" className="h-9 w-auto" data-id="element-45" data-mp="3jq9lscfb75ws" />
          <p className="mt-2 text-xs uppercase tracking-[0.18em] text-ink-muted" data-id="element-46" data-mp="3esq9hi26937h">Admin</p>
        </div>
        <nav aria-label="Adminnavigation" className="flex flex-col gap-1 px-3" data-id="element-47" data-mp="3thmfl9ko465g">
          {nav.map(item => <NavLink key={item.to} to={item.to} end={item.end} className={({
          isActive
        }) => `inline-flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm transition-colors duration-200 ease-smooth ${isActive ? 'bg-ink text-white' : 'text-ink-soft hover:bg-canvas hover:text-ink'}`} data-id="element-48" data-mp="3ol5r2e9k3pru">
              <item.icon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-49" data-mp="jd8plk05xvu2" />
              <span className="flex-1" data-id="element-50" data-mp="jbe1jwtlhnlr">{item.label}</span>
              {item.to === '/admin/henvendelser' && newEnquiries > 0 && <span className="rounded-full bg-accent px-1.5 py-0.5 text-[11px] font-semibold text-white" data-id="element-51" data-mp="s627zqawpbc5">
                  {newEnquiries}
                </span>}
            </NavLink>)}
        </nav>
        <button type="button" onClick={handleLogout} className="mx-3 mb-6 mt-auto inline-flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm text-ink-soft transition-colors duration-200 ease-smooth hover:bg-canvas hover:text-ink" data-id="element-52" data-mp="1251i7dbblf19">
          <LogOutIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-53" data-mp="38to9181gxgge" />
          Log ud
        </button>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col" data-id="element-54" data-mp="1pzv0xumu3knj">
        <header className="sticky top-0 z-40 border-b border-line bg-white/95 px-5 py-3 backdrop-blur lg:hidden" data-id="element-55" data-mp="1l8lef2wl0xfv">
          <div className="flex items-center justify-between" data-id="element-56" data-mp="1h5yjgt4m6weg">
            <div data-id="element-57" data-mp="1h4dmyxyqp3dy">
              <img src={company.logoWide} alt="LYKKEVÆRK" className="h-8 w-auto" data-id="element-58" data-mp="1c7x2qeunv965" />
              <p className="mt-1 text-[10px] uppercase tracking-[0.18em] text-ink-muted" data-id="element-59" data-mp="1c5u456fg07pt">Admin</p>
            </div>
            <button type="button" onClick={handleLogout} className="inline-flex h-9 items-center gap-2 rounded-full border border-line px-3.5 text-sm text-ink-soft" data-id="element-60" data-mp="24wluvodqo45r">
              <LogOutIcon className="h-4 w-4" aria-hidden="true" data-id="element-61" data-mp="1uyxwmogxceiu" />
              Log ud
            </button>
          </div>
        </header>

        {dataError && <p role="alert" className="flex items-start gap-2 border-b border-danger/30 bg-danger/10 px-5 py-3 text-sm text-danger md:px-8" data-id="element-62" data-mp="jizkgbqg9cde">
            <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-63" data-mp="27dkvj9wcq4o6" />
            {dataError}
          </p>}

        {rulesError && <p role="status" className="flex items-start gap-2 border-b border-line bg-accent-soft px-5 py-3 text-sm text-accent-deep md:px-8" data-id="element-64" data-mp="1yg26zvji187j">
            <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-65" data-mp="2r352eesvp2tk" />
            {rulesError}
          </p>}

        <main className="min-w-0 flex-1 pb-24 lg:pb-0" data-id="element-66" data-mp="2v3ys9dpvsrp3">
          <Outlet data-id="element-67" data-mp="2h5qx9bceo0gk" />
        </main>

        <nav aria-label="Adminnavigation" className="fixed bottom-0 left-0 right-0 z-40 flex border-t border-line bg-white/95 backdrop-blur lg:hidden" data-id="element-68" data-mp="2h4fm2qgmrqff">
          {nav.map(item => <NavLink key={item.to} to={item.to} end={item.end} className={({
          isActive
        }) => `relative flex flex-1 flex-col items-center gap-1 py-3 text-[11px] transition-colors duration-200 ease-smooth ${isActive ? 'text-accent' : 'text-ink-muted'}`} data-id="element-69" data-mp="15oqx5tjtghbz">
              <item.icon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" data-id="element-70" data-mp="1c5amoiwzq55z" />
              {item.label}
              {item.to === '/admin/henvendelser' && newEnquiries > 0 && <span className="absolute right-1/4 top-1.5 h-2 w-2 rounded-full bg-accent" aria-hidden="true" data-id="element-71" data-mp="jiy694t2uoaz" />}
            </NavLink>)}
        </nav>
      </div>
    </div>;
}